import React from "react";
import { Card, CardBody, CardText, Col, Row, } from "reactstrap";


const ProfileAllScrappedDataCard = ({ title, data, height }) => {
  return (
    <Card style={{ height: `${height}px`, overflowY: 'auto', borderRadius: "9px", boxShadow: "0 4px 8px 0 rgba(0,0,0,0.2)" }}>
      <CardBody>
        <h5 style={{ fontSize: "18px", fontWeight: "700" }}>{title}</h5>
        {data?.map((item, i) => {
          if (!item.value || !item?.value?.length) return null
          if (item?.type === "image") {
            return (
              <div className="my-2" key={i}>
                <p style={{ marginBottom: "0.5rem", fontWeight: 500, color: "#3B4758" }}>
                  {item?.value}
                </p>
                <Card style={{ border: "1px solid #E6E6E6D9", overflow: 'hidden', boxShadow: "none", gap: 0 }}>
                  <img
                    src={item?.file}
                    alt="Item"
                    className="card-img-top"
                    style={{ objectFit: "contain", width: "100%", maxHeight: "200px", backgroundColor: "#f9f9f9" }}
                  />
                  <div
                    style={{
                      borderTop: "1px solid #DADADA",
                      display: "flex",
                      alignItems: "center",
                      gap: '5px',
                      padding: "8px 16px",
                    }}
                  >
                    <h5 style={{ fontSize: "14px", fontWeight: 600 }}>Source: </h5>
                    <a
                      href={item?.source}
                      target="_blank"
                      style={{
                        color: "#508CFF",
                        fontSize: "12px",
                        fontWeight: 500,
                        whiteSpace: "nowrap",
                      }} rel="noreferrer"
                    >
                      {item?.source}
                    </a>
                  </div>
                </Card>
              </div>
            );
          }

          // const value = typeof item?.value === "object" ? item?.product || item?.category : item?.value;
          return (
            <div className="my-2" key={i}>
              {/* <p style={{ marginBottom: "0.5rem", fontWeight: 500, color: "#3B4758" }}>
                {value}
              </p> */}
              <Card style={{ border: "1px solid #E6E6E6D9", overflow: 'hidden', boxShadow: "none", gap: 0 }}>
                <CardBody>
                  <Row className="align-items-center mb-3">
                    <Col xs="auto">
                      <img src='/text2.png' width="20px" height="15px" alt="Text Icon" />
                    </Col>
                    <Col>
                      <p style={{ fontWeight: 500 }}>{Array.isArray(item.value) ? item.value?.join(', ') : item.value}</p>
                    </Col>
                  </Row>
                  <CardText
                    style={{
                      fontSize: "13px",

                      display: "-webkit-box",
                      overflow: "hidden",
                      WebkitBoxOrient: "vertical",
                      WebkitLineClamp: 5,
                    }}
                  >
                    {item?.text}
                  </CardText>
                </CardBody>
                <div
                  style={{
                    borderTop: "1px solid #DADADA",
                    display: "flex",
                    alignItems: "center",
                    gap: "2px",
                    padding: "8px 16px",
                  }}
                >
                  <h5 style={{ fontSize: "14px", fontWeight: 600 }}>Source: </h5>
                  <a
                    href={item?.source}
                    target="_blank"
                    style={{
                      color: "#508CFF",
                      fontSize: "12px",

                      fontWeight: 500,
                      whiteSpace: "nowrap",
                    }} rel="noreferrer"
                  >
                    {item?.source}
                  </a>
                </div>
              </Card>
            </div>
          );
        })}
        {data?.length === 0 && (
          <div className="text-center my-5">
            <h4 style={{ fontSize: "28px", fontWeight: 600 }}>
              Not found
            </h4>
            <h6 style={{ fontSize: "16px", color: "#999" }}>
              {`We didn't find anything for ${title}`}
            </h6>
            <img src='/no-data.png' alt="No data" style={{ height: "200px", objectFit: "contain" }} />
          </div>
        )}
      </CardBody>
    </Card>
  );
};

export default ProfileAllScrappedDataCard;
